import {QueryClient} from "@tanstack/react-query";

export const queryClient = new QueryClient({
  // queryCache,
  defaultOptions: {
    queries: {
      cacheTime: 0,
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      retry: false,
    },
    mutations: {
      retryDelay: 2000,
    },
  },
});
